import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import './App.css';
import 'typeface-roboto';
import AppBar from '../../components/AppBar/AppBar';
import Drawer from '../../components/Drawer/Drawer';
import Dashboard from '../../pages/Dashboard';
import LoginPage from '../../pages/Login';
import ProfilePage from '../../pages/Profile';
import ReportsPage from '../../pages/Reports/Reports';
import UsersPage from '../../pages/Users/Users';
import ActivityPage from '../../pages/Activity';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import Page404 from '../../pages/404';
import Snackbar from '../../components/Snackbar/Snackbar';
import UserReportAdd from '../UserReportAdd/UserReportAdd';
import { ROLE_ADMIN } from '../../constants/roles';


const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    height: '100%',
  },
  contentLogged: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 5,
    marginTop: 55,
    marginBottom: 65,
    height: '100%',
    [theme.breakpoints.up('lg')]: {
      width: 'calc(100% - 240px)',
      marginLeft: 240,
    },
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
    },
  },
});

const propTypes = {
  classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
  authStore: mobxPropTypes.observableObject.isRequired,
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
    };
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
  }

  handleDrawerToggle() {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  }

  render() {
    const { classes, authStore } = this.props;
    const { mobileOpen } = this.state;
    const { user, isLoggedIn, isReady } = authStore;
    const AppBarComponent = isLoggedIn ? (
      <AppBar
        toggleHandler={this.handleDrawerToggle}
      />
    ) : null;
    const DrawerComponent = isLoggedIn ? (
      <Drawer
        mobileOpen={mobileOpen}
        toggleHandler={this.handleDrawerToggle}
        role={user.role}
      />
    ) : null;

    const AddComponent = isLoggedIn && user.role === ROLE_ADMIN ? <UserReportAdd /> : null;

    return (
      <Router>
        {isReady && (
          <div>
            <div className={classes.root}>
              {AppBarComponent}
              {DrawerComponent}

              <main
                className={isLoggedIn ? classes.contentLogged : classes.content}
              >
                <Switch>
                  <Route path="/login" component={LoginPage} />
                  <PrivateRoute
                    exact
                    path="/"
                    component={Dashboard}
                    roles={[ROLE_ADMIN]}
                  />
                  <PrivateRoute exact path="/profile" component={ProfilePage} />
                  <PrivateRoute path="/reports" component={ReportsPage} />
                  <PrivateRoute
                    path="/users"
                    component={UsersPage}
                    roles={[ROLE_ADMIN]}
                  />
                  <PrivateRoute
                    path="/activity"
                    component={ActivityPage}
                    roles={[ROLE_ADMIN]}
                  />
                  <Route component={Page404} />
                </Switch>
              </main>
              <Snackbar />
            </div>
            {AddComponent}
          </div>
        )}
      </Router>
    );
  }
}

App.propTypes = propTypes;
const AppStore = inject('authStore', 'loadingStore')(observer(App));
export default withStyles(styles, { withTheme: true })(AppStore);



// WEBPACK FOOTER //
// ./src/containers/App/App.js